import { getIntendType, crossSiteCheckUrl } from '../components/common/Helpers/index';
import { getChannelId } from './HttpService';
import { getSecureBaseUrl } from './UrlMapperService';
import { apiUrls } from '../constants/apiUrl';

export const USER_INFO = 'USERINFO';
export const HOMEPLAN = 'HOMEPLAN';
export const CONTINUE_CLICK = 'CONTINUE CLICK';
export const ADDTOCART_BUTTON_CLICK = 'Add to cart button click';
export const REMOVE_BUTTON_CLICK = 'Remove button click';
export const CONFIRMADDRESS_CONTINUECLICK = 'confirm address continue click';
export const ADDHOME_PHONECLICK = 'Add home phone cta click';
export const SKIPBUTTON_CLICK = 'Skip button click';
export const ADDON_CONTINUE_CLICK = 'Continue button click';
export const SELFSETUP_CONTINUE_CLICK = 'Selected self setup continue click';
export const PROFSETUP_CONTINUE_CLICK = 'Selected prof setup continue click';
export const ACCESSORIES = 'ACCESSORIES';
export const SETUP_CHOICE = 'SETUPCHOICE';

export const logMetrics = (methodName, userinfo, clicktype) => {
  const infodata = userinfo;
  const eventType = 'INFO';
  const pageName = window.location.pathname
    .split('/')
    .pop()
    .split('.')[0];
  const data = {
    messageType: clicktype,
    eventType,
    errorMessage: '',
    pageUrl: window.location.href,
    loggerMessage: {
      message: infodata,
      loglevel: 'loglevel',
      id: '',
      userAgent: navigator.userAgent,
      pageTitle: pageName,
      host: window.location.host,
      stackTrace: {},
      componentStack: methodName,
    },
  };
  const postUrl = crossSiteCheckUrl(`${getSecureBaseUrl()}${apiUrls().errorLogUrl}`);
  const xhr = new XMLHttpRequest();
  xhr.open('POST', postUrl);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('channelId', getChannelId());
  xhr.setRequestHeader('flowName', `${getIntendType()}`);
  xhr.send(JSON.stringify(data));
};
